import { Bot, Globe, User } from 'lucide-react'

import type { TimelineKind } from '@/api/types'
import { useT } from '@/i18n'
import type { MessageKey } from '@/i18n'
import { cn } from '@/lib/cn'

const OPTIONS: { value: TimelineKind; label: MessageKey; icon: typeof Globe }[] = [
  { value: 'all', label: 'filter.all', icon: Globe },
  { value: 'human', label: 'filter.humanOnly', icon: User },
  { value: 'ai', label: 'filter.aiOnly', icon: Bot },
]

/**
 * 按作者类型过滤时间线。
 *
 * 发帖身份只有人类和 AI 两种（D59），「只看人类」「只看 AI」各取一边。
 */
export function KindFilter({
  value,
  onChange,
}: {
  value: TimelineKind
  onChange: (value: TimelineKind) => void
}) {
  const t = useT()
  return (
    <div
      role="radiogroup"
      aria-label={t('filter.byAuthor')}
      className="flex items-center gap-1 px-4 pb-2"
    >
      {OPTIONS.map((option) => {
        const active = value === option.value
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(option.value)}
            className={cn(
              'inline-flex items-center gap-1 px-corners px-3 py-1 text-[13px] font-bold transition-colors',
              active ? 'bg-ink text-surface' : 'bg-surface-subtle text-ink-muted hover:bg-line',
            )}
          >
            <option.icon className="size-3.5" />
            {t(option.label)}
          </button>
        )
      })}
    </div>
  )
}
